import React from 'react';
import Button from '../../Button';
import { GeneralTabStyle } from './GeneralTab.styles';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

const GeneralTab = () => {
  const { user, onLogout } = useContextHook(AuthContext, v => ({
    user: v.user,
    onLogout: v.onLogout,
  }));
  return (
    <>
      <GeneralTabStyle>
        <div className="holder">
          <strong className="title">Email</strong>
          <span className="email">{user?.email}</span>
        </div>
        <div className="holder flex">
          <div className="text-box">
            <strong className="title">Log out of my account</strong>
            <p>Terminate your current session on this device</p>
          </div>
          <Button variant="secondary" width="140px" onClick={onLogout}>
            Log Out
          </Button>
        </div>
      </GeneralTabStyle>
    </>
  );
};

export default GeneralTab;
